import { produce } from "immer";
import _ from "lodash";
import { Store } from "reducers/rootReducer";

/* STATE */

type State = {
  refreshAllFormData: boolean;
};

const initialState: State = {
  refreshAllFormData: false,
};

/* ACTIONS */
const REFRESH_ALL_FORM_DATA = "app/entity/REFRESH_ALL_FORM_DATA";

type Action = {
  type: typeof REFRESH_ALL_FORM_DATA;
  payload: boolean;
};

/* REDUCER */

export default function reducer(state = initialState, action: Action): State {
  return produce(state, draft => {
    switch (action.type) {
      case REFRESH_ALL_FORM_DATA:
        draft.refreshAllFormData = action.payload;
        break;
      default:
        break;
    }
  });
}

/* ACTION CREATORS */

export const setRefreshAllFormData = (payload: boolean): Action => ({
  type: REFRESH_ALL_FORM_DATA,
  payload,
});

/* SELECTORS */

export const selectRefreshAllFormData = (app: Store) =>
  app.entity.refreshAllFormData;
